import { IEventDetailsDTO } from '../../../../../api/events.dao';
import { ISalesforceOrderDTO } from '../../../../../api/salesforce-order.dao';
import { convertBoolTypeForMixPanel } from '../../../../../tracking-service/tracking-values';
import { getProductsGrandTotal } from './salesforce-order-display.mapper';

/** Builds the Mixpanel property bag for the 'View Salesforce Order' event. */
export class SalesforceOrderTrackingMapper {
    public static toTrackingEvent(event: IEventDetailsDTO, order?: ISalesforceOrderDTO): Record<string, string> {
        const products = order?.products ?? [];
        return {
            'Event ID': event?.eventId != null ? String(event.eventId) : '',
            'OE Number': event?.oeNumber ?? '',
            'Salesforce OrderID': order?.orderId ?? event?.orderId ?? '',
            'Business Line': event?.businessLine ?? '',
            'Order Status': order?.order?.orderStatus ?? '',
            'Billing Status': order?.order?.billingStatus ?? '',
            'Event Type (OE Defined)': order?.order?.eventType ?? '',
            'Event Type (Client Defined)': order?.order?.eventTypeClient ?? '',
            'Sync to Teams': order?.order?.syncToTeams == null
                ? '' : convertBoolTypeForMixPanel(order.order.syncToTeams),
            'No Staffing Required': order?.order?.noStaffRequired == null
                ? '' : convertBoolTypeForMixPanel(order.order.noStaffRequired),
            'Hybrid Event': order?.order?.hybridEvent ?? '',
            'High Profile Order': order?.order?.highProfileOrder == null
                ? '' : convertBoolTypeForMixPanel(order.order.highProfileOrder),
            'High Profile Reasoning': order?.order?.highProfileReasoning ?? '',
            'High Profile Attendee Details Provided': convertBoolTypeForMixPanel(Boolean(order?.order?.highProfileAttendeeDetails)),
            'Account Legal Entity': order?.order?.accountLegalEntity ?? '',
            'Is This Event Repeatable': order?.order?.isThisEventRepeatable ?? '',
            'Opportunity': order?.order?.opportunityName?.name ?? '',
            'Channel/Agency Referral': order?.order?.channelAgencyReferral?.name ?? '',
            'Host LOB': order?.order?.hostLob ?? '',
            'Host Sub LOB': order?.order?.hostSubLob ?? '',
            'Lasso Sync Status': order?.order?.lassoSyncStatus ?? '',
            'Lasso Sync Datetime': order?.order?.lassoSyncDatetime ?? '',
            'Teams Created': order?.order?.teamsCreated ?? '',
            'Teams Channel Archived': order?.order?.processedForArchive == null
                ? '' : convertBoolTypeForMixPanel(order.order.processedForArchive),
            'Billing Time Sensitivity': order?.order?.billingTimeSensitivity ?? '',
            'Product Count': String(products.length),
            'Total Value': String(getProductsGrandTotal(products)),
        };
    }
}
